export enum QueryKey {
  Account = 'account-me',
  BrandWiki = 'brand-wiki',
  PostIdeas = 'post-ideas',
  Post = 'Post',
  Task = 'Task',
  Clients = 'Clients',
  connectedChannels = 'connectedChannels',
  WikiSettings = 'WikiSettings',
  Pricing = 'Pricing',
  UsersList = 'UsersList',
  LlmLogs = 'LlmLogs',
  MarketingChannels = 'MarketingChannels',
  StripePrices = 'stripe-config',
  UserSubscriptions = 'user-subscriptions',
}
